import { render, staticRenderFns } from "./appltDecoration.vue?vue&type=template&id=492f3299&scoped=true"
import script from "./appltDecoration.vue?vue&type=script&lang=js"
export * from "./appltDecoration.vue?vue&type=script&lang=js"
import style0 from "./appltDecoration.vue?vue&type=style&index=0&id=492f3299&prod&lang=less&scoped=true"
import style1 from "./appltDecoration.vue?vue&type=style&index=1&id=492f3299&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f3299",
  null
  
)

export default component.exports